export const SET_EVENTS = 'SET_EVENTS'
export const SET_MENUS = 'SET_MENUS'
export const SET_TAPS = 'SET_TAPS'
export const SET_SPECIALS = 'SET_SPECIALS'
export const ADD_EVENT = 'ADD_EVENT'
export const ADD_TAP = 'ADD_TAP'
export const ADD_MENU = 'ADD_MENU'
export const ADD_ITEM = 'ADD_ITEM'
export const ADD_SPECIAL = 'ADD_SPECIAL'
